<script lang="ts">
  import { onMount } from "svelte";
  import { fly } from "svelte/transition";
  import Confetti from "./Confetti.svelte";

  let container = $state();
  let text = $state();
  interface Props {
    position: { x: number; y: number };
    children?: import('svelte').Snippet;
  }

  let { position = $bindable(), children }: Props = $props();
  let showModule = $state(true);
  let timeout;

  onMount(() => {
    var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    if (position.x + text.offsetWidth > w) {
      position.x = w - text.offsetWidth - 40;
    }
    container.style.left = position.x - text.offsetWidth / 2 + "px";
    container.style.top = position.y + "px";
    showModule = false;
  });
</script>

<div class={"fixed flex justify-center z-30 pointer-events-none "} bind:this={container}>
  {#if showModule}
    <div
      bind:this={text}
      out:fly={{ y: -110, duration: 3000 }}
      class={" inline-block text-H2 font-bold p-2 bg-PurplePrimary text-white"}
    >
      {@render children?.()}
    </div>
    <div
      out:fly={{ y: -110, duration: 2000 }}
      class="absolute right-0 left-0 top-0 bottom-0 m-auto w-7"
    >
      <Confetti numberOfElements={25} timeout={2000} />
    </div>
  {/if}
</div>
